import { Box, Button, buttonClasses, ButtonProps } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";

export type ActiveFilterButtonProps = ButtonProps & {
  label: string;
  value: string;
};

export function ActiveFilterButton({
  label,
  value,
  sx,
  ...buttonProps
}: ActiveFilterButtonProps) {
  return (
    <Button
      variant="outlined-contained"
      color="primary"
      size="small"
      endIcon={<CancelIcon />}
      sx={[
        {
          p: 1,
          py: 0.5,
          whiteSpace: "nowrap",
          textTransform: "unset",
          fontSize: "13px",
          lineHeight: "18px",
          gap: 1,
          [`.${buttonClasses.endIcon}`]: {
            m: 0,
            svg: { fontSize: "24px", opacity: 0.5 },
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...buttonProps}
    >
      <Box component="span">
        {label}{" "}
        {value.length > 0 && (
          <Box component="span" fontWeight={700}>
            {value}
          </Box>
        )}
      </Box>
    </Button>
  );
}
